<div class="modal fade fs--1" id="selection-feature-modal" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog fs--1 modal-dialog-centered" role="document" style="max-width: 900px">
    <div class="modal-content fs--1 position-relative">
      <div class="position-absolute top-0 end-0 mt-2 me-2 z-index-1">
        <button class="btn-close btn btn-sm btn-circle d-flex flex-center transition-base" #closebutton
          data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body fs--1 p-0">
        <div class="rounded-top-lg py-3 ps-4 pe-6">
          <h2 class="mb-1 text-center" style="font-size: 20px; font-weight: bold;" id="modalExampleDemoLabel">
            Choose Module
          </h2>
        </div>

        <div class="p-2 pb-0 table-responsive">
          <form [formGroup]="subscriptionForm">
            <div formArrayName="Rows">
              <table class="table table-bordered fs--1 mb-0">
                <thead class="text-center">
                  <tr>
                    <th scope="col" class="text-white">#</th>
                    <th scope="col" class="text-white">Features</th>
                    <th scope="col">Choice</th>

                    <!-- <th scope="col" class="text-primary ">Description</th> -->
                    <th scope="col" style="color: rgb(225, 154, 21);">Price</th>
                    <!-- <th scope="col" class="text-white ">Select</th> -->
                  </tr>
                </thead>
                <tbody class="text-center">
                  <tr *ngFor="
                    let feature of subscriptionForm.get('Rows')['controls'];
                    let i = index
                  " [formGroupName]="i">
                    <td style="padding-top: 1.3rem !important;">{{ i + 1 }}</td>

                    <td>
                      <input readonly type="text" formControlName="featureName" class="form-control form-control-sm" style="text-transform: capitalize;font-weight: bold;" />
                    </td>
                    <td style="padding-top: 1.3rem !important;">
                      <span style="justify-content: center" class="d-flex form-check form-check-sm">
                        <input class="form-check-input custom-checkbox" formControlName="active" id="flexCheckDefault"
                          type="checkbox" [checked]="true"
                          (change)="onCheckChange(feature.value,$event.target.checked,i)" />
                      </span>
                    </td>

                    <td>
                      <input readonly type="text" formControlName="price" class="form-control form-control-sm" />
                    </td>
                    <!-- <td style="padding-top: 1.3rem !important;">
                                          <span style="justify-content: center"
                                              class="d-flex form-check form-check-sm">
                                              <input class="form-check-input" formControlName="active"
                                                  id="flexCheckDefault" type="checkbox" [checked]="true"
                                                  (change)="onCheckChange(feature.value,$event.target.checked,i)" />
                                          </span>
                                      </td> -->
                  </tr>
                </tbody>
                <tfoot>
                  <tr class="text-center fs--1">
                    <th scope="col"></th>
                    <th scope="col"></th>
                    <th scope="col" style="color: #000000"> Total</th>
                    <th scope="col" style="color: #000000">
                      {{ total }}
                    </th>
                  </tr>
                  <tr class="text-center fs--1">
                    <th scope="col" style="color: #000000">Plan Details</th>
                    <th scope="col" style="color: #000000">
                      {{ planDays }}
                    </th>
                    <th scope="col" style="color: #000000">Grand Total</th>
                    <th scope="col" style="color: #000000">
                      {{ grandTotal }}
                    </th>
                  </tr>
                </tfoot>
              </table>
            </div>
          </form>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-outline-primary fs--1" type="button" data-bs-dismiss="modal">
          Close
        </button>
        <button class="btn btn-outline-primary fs--1" type="button" (click)="premiumPostSubscription()" id="closeModal"
          [disabled]="grandTotal ==  null">Buy Now</button>
      </div>
    </div>
  </div>
</div>



<div class="container-fluid pricing-image ">
  <div class="backButton ">
    <a class="btn btn-outline-primary btn-light mt-3 m-3 backButton" style="float:right!important;" (click)="goTOBack()">Back</a>
  </div>
  <div class="pricing-cards-container">

    <div class="pricing-card">
      <img src="../../../assets/images/Frame.png" alt="Pro Plan" class="card-image">
      <h2 class="">Pro</h2>
      <p class="description mb-6" style="color: gray; font-size: 15px;">
        Basic + HRMS, Marketing, Accounting,
        Shopping, Warehouse
      </p>
      <span class="normal-text" >Unlock Exclusive Deals with <br>
        Our Special Price List!</span>


      <div class="mt-6">
        <button type="button" class="btn btn-primary btn-rounded mb-3 btn-lg-custom" style="background-color: #643885;"
          (click)="premiumPostSubscription()">CHOOSE PRO</button>
      </div>
      <div>
        <button type="button" class="btn btn-primary btn-rounded mb-2 btn-lg-custom" routerLink="/pages">FREE
          TRIAL</button>
      </div>
    </div>

    <div class="pricing-card">
      <img src="../../../assets/images/Frame (2).png" alt="Basic Plan" class="card-image">
      <h2 class="">Basic</h2>
      <p class="description mb-6" style="color: gray;font-size: 15px;">Dashboard, Inventory, Contact, Product, Bank, etc
      </p>

      <h2 class="mb-6  normal-text">
        <span style="white-space: nowrap;"> <span style="font-size: 32px;font-weight: 800;"><sup class="text-secondary" style="font-weight: normal;"><sup>&#8377;</sup></sup></span></span>
        <span> | </span>
        <span class="text-secondary p-0 m-0" >Per day
        </span>
      </h2>

      <div>
        <button type="button" class="btn btn-primary btn-rounded mb-3 btn-lg-custom" style="background-color: #352d3b;"
          (click)="basicPostSubscription()">GET STARTED</button>
      </div>
      <div>
        <button type="button" class="btn btn-primary btn-rounded  btn-lg-custom" routerLink="/pages">FREE TRIAL</button>
      </div>
    </div>

    <div class="pricing-card">
      <img src="../../../assets/images/Frame.png" alt="Customize Plan" class="card-image">
      <h2 class="">Customize</h2>
      <p class="description mb-6" style="color: gray; font-size: 15px;">
        Create Your Own Customized Plan.
      </p>
      <p class="normal-text mb-6">Affordable Luxury: Explore<br>
        Our Price List and Discover<br>
        Customized Plans!
      </p>
      <div>
        <button type="button" class="btn btn-primary btn-rounded mb-3 btn-lg-custom" data-bs-toggle="modal"
          data-bs-target="#selection-feature-modal" style="background-color: #643885;">CHOOSE OWN</button>
      </div>
      <div>
        <button type="button" class="btn btn-primary btn-rounded mb-2 btn-lg-custom" routerLink="/pages">FREE
          TRIAL</button>
      </div>
    </div>

  </div>
</div>
